import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule,APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import {
  DxCheckBoxModule,
  DxDataGridModule,
  DxSelectBoxModule,
  DxTextBoxModule
} from 'devextreme-angular';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SelectivePreloadingStrategy } from './selective-preloading-strategy';
import {
  AdminService,
  ApiService,
  AuthGuard,
  CallService,
  FooterComponent,
  HeaderComponent,
  JwtService,
  MyserviceService,
  PatientService,
  SharedModule,
  UserService
} from './shared';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';
import { CanDeactivateGuard } from './shared/can-deactivate/can-deactivate.guard';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';

import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DxTreeListModule } from "devextreme-angular";
import { TourMatMenuModule } from 'ngx-tour-md-menu';
import { AndriodpopupComponent } from './andriodpopup/andriodpopup.component';
import { AppRoutingModule } from './app.routing';
import { AppstoreComponent } from './appstore/appstore.component';
import { AuthModule } from './auth/auth.module';
import { BrowsernotificationComponent } from './browsernotification/browsernotification.component';
import { CareconformationComponent } from './careconformation/careconformation.component';
import { CarepasswordModule } from './carepassword/carepassword.module';
import { ChangepwdModule } from './changepwd/changepwd.module';
import { ClientSetupComponent } from './client-setup/client-setup.component';
import { CnmappingComponent } from './cnmapping/cnmapping.component';
import { ConformComponent } from './conform/conform.component';
import { DateformateUsPipe } from './dateformate-us.pipe';
import { ForgotpwdModule } from './forgotpwd/forgotpwd.module';
import { HospitalModule } from './hospital/hospital.module';
import { LoginascarenavicatorComponent } from './hospital/loginascarenavicator/loginascarenavicator.component';
import { IpcaptureModule } from './ipcapture/ipcapture.module';
import { LoginasmodeComponent } from './loginasmode/loginasmode.component';
import { ManageClientUserComponent } from './manage-client-user/manage-client-user.component';
import { OnlyNumberDirective } from './only-number.directive';
import { OnlycharactersDirective } from './onlycharacters.directive';
import { OtpModule } from './otp/otp.module';
import { PatientModule } from './patient/patient.module';
import { homeModule } from './patienthome/patienthome.module';
import { EmailunsubscribeComponent } from './patientonboard/emailunsubscribe/emailunsubscribe.component';
import { PatientonboardModule } from './patientonboard/patientonboard.module';
import { remembertempComponent } from './patientonboard/remembertemp/remembertemp.component';
import { PAuthModule } from './pauth/pauth.module';
import { ResetpassModule } from './resetpass/resetpass.module';
import { ResSupportModule } from './ressupport/ressupport.module';
import { SauthModule } from './sauth/sauth.module';
import { SessiontempComponent } from './sessiontemp/sessiontemp.component';
import { CanSessionDeactivateGuard } from './shared/can-deactivate/can-sessiondeactive.guard';
import { SignUpModule } from './signUp/signup.module';
import { StykerLoginComponent } from './styker-login/styker-login.component';
import { SucesstempComponent } from './sucesstemp/sucesstemp.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
//const rootRouting: ModuleWithProviders = RouterModule.forRoot([], { useHash: true });
//import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from "./shared/config/app-config";
import { NeedHelpComponent } from './need-help/need-help.component';
import { Observable, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";
export function initializeApp(http: HttpClient) {
  return (): Observable<any> => {
    const url =  `./assets/config/environment.json`;
    return http.get(url).pipe(
      tap(envConfig => {
           Object.assign(environment, envConfig);
      }),
      catchError(() => {
        console.error('Failed to load config, using default');
        return of(environment);
      })
    );
  };
}


// const apiBase = environment.api_url + '/api/getLanguageFile/';
export function HttpLoaderFactory(http: HttpClient) {
  // return new TranslateHttpLoader(http, apiBase);  // Path to access JSON
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}
@NgModule({
  providers: [
    ApiService,
    AuthGuard,
    JwtService,
    PatientService,
    UserService,
    AdminService,
    SelectivePreloadingStrategy,
    CanDeactivateGuard,
    CanSessionDeactivateGuard,
    MyserviceService,
    CallService,
    {
    provide: APP_INITIALIZER, useFactory: initializeApp, deps: [HttpClient], multi: true 
    },
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    FooterComponent,
    HeaderComponent,
    OnlyNumberDirective,
    OnlycharactersDirective,
    SucesstempComponent,
    UnsubscribeComponent,
    SessiontempComponent,
    LoginascarenavicatorComponent,
    BrowsernotificationComponent,
    LoginasmodeComponent,
    EmailunsubscribeComponent,
    DateformateUsPipe,
    CnmappingComponent,
    StykerLoginComponent,
    ClientSetupComponent,
    ManageClientUserComponent,
    AppstoreComponent,
    AndriodpopupComponent,
    NeedHelpComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    MatCardModule,
    MatDialogModule,
    TourMatMenuModule.forRoot(),
    BrowserAnimationsModule,
    MatIconModule,
    FormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    PdfViewerModule,
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    CollapseModule.forRoot(),
    TooltipModule.forRoot(),
    MatProgressBarModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    SharedModule,
    homeModule,
    ResSupportModule,
    NgxSliderModule,
    AuthModule,
    PAuthModule,
    SignUpModule,
    SauthModule,
    ForgotpwdModule,
    ChangepwdModule,
    HospitalModule,
    PatientModule,
    PatientonboardModule,
    AppRoutingModule,
    OtpModule,
    ToastrModule.forRoot(),
    ImageCropperModule,
    IpcaptureModule,
    ResetpassModule,
    CarepasswordModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxTreeListModule
  ],
  entryComponents: [
    ConformComponent,
    CareconformationComponent,
    SucesstempComponent,
    SessiontempComponent,
    remembertempComponent,
    AndriodpopupComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  // Diagnostic only: inspect router configuration
  constructor(router: Router) {
    // //////console.log('Routes: ', JSON.stringify(router.config, undefined, 2));
  }
}
// platformBrowserDynamic().bootstrapModule(AppModule);
